/**
 * Kopfzeile über dem Monatsraster — ‹ Monat › · Heute · Aktivität · ＋.
 * Am Telefon eine einzige Zeile (13.10.2026), am Rechner wie gehabt.
 * Bis 13.10.2026 Teil von PlanungPage; dort stand auch der Projektfilter.
 */
import { MONTHS, firstOfMonth } from "./planer-utils";

type Props = {
  month: Date;
  /** Laufender Monat UND heute gewählt — dann bringt „Heute" am Telefon nichts. */
  heuteUnnoetig: boolean;
  offeneAkt: number;
  onMonat: (m: Date) => void;
  onAktivitaet: () => void;
  onNeu: () => void;
};

export default function PlanerKopf({ month, heuteUnnoetig, offeneAkt, onMonat, onAktivitaet, onNeu }: Props) {
  return (
    <>
      {/* Projektfilter entfernt (13.10.2026): nie benutzt — welche Tage an einem
          Projekt hängen, zeigt das Projekt selbst. Auf dem Telefon steht alles
          in EINER Zeile, damit der Kalender und die Tagesliste nach oben rücken. */}
      <div className="pl-controls">
        <div className="pl-monthnav">
          <button className="pl-navbtn" type="button" onClick={() => onMonat(new Date(month.getFullYear(), month.getMonth() - 1, 1))} aria-label="Vormonat">‹</button>
          <div className="pl-monthlabel">
            <span className="pl-ml-lang">{MONTHS[month.getMonth()]} {month.getFullYear()}</span>
            {/* Telefon: das Jahr nur, wenn es nicht das laufende ist; unter 360 px der Monat abgekürzt. */}
            <span className="pl-ml-kurz" aria-hidden="true">
              {MONTHS[month.getMonth()]}{month.getFullYear() !== new Date().getFullYear() ? ` ${month.getFullYear()}` : ""}
            </span>
            <span className="pl-ml-mini" aria-hidden="true">
              {MONTHS[month.getMonth()].slice(0, 3)}{month.getFullYear() !== new Date().getFullYear() ? ` ${String(month.getFullYear()).slice(2)}` : ""}
            </span>
          </div>
          <button className="pl-navbtn" type="button" onClick={() => onMonat(new Date(month.getFullYear(), month.getMonth() + 1, 1))} aria-label="Folgemonat">›</button>
          <button
            className={`pl-navbtn pl-navbtn-wide${heuteUnnoetig ? " pl-heute-unnoetig" : ""}`}
            type="button"
            onClick={() => onMonat(firstOfMonth(new Date()))}
          >Heute</button>
        </div>
        <div className="pl-filterrow">
          {/* Der Zaehler ist der eigentliche Zweck: eine Bewerbung, die niemand
              sieht, ist eine unbeantwortete Bewerbung. Ohne Offenes bleibt der
              Knopf still stehen, statt eine leere Null zu zeigen. */}
          <button
            type="button"
            className="pl-aktbtn"
            onClick={onAktivitaet}
            title="Was aus der Team-App hereinkommt"
            aria-label={offeneAkt > 0 ? `Aktivität, ${offeneAkt} offen` : "Aktivität"}
          >
            <svg className="pl-akt-symbol" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
            </svg>
            <span className="pl-akt-text">Aktivität</span>
            {offeneAkt > 0 && <span className="pl-aktzahl">{offeneAkt}</span>}
          </button>
          <button
            type="button"
            className="pl-neubtn"
            aria-label="Neuer Termin"
            onClick={onNeu}
          >＋<span className="pl-neu-text"> Neuer Termin</span></button>
        </div>
      </div>
    </>
  );
}
